import { useEffect, useState } from "react";

import apiClient from "../services/apiClient";
import { CanceledError } from "axios";

const useData = (endpoint, requestConfig, deps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState();
  const dependency = deps ? [...deps] : [];

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller);
    return () => {
      controller.abort();
      setData();
    };
  }, dependency);

  const fetchData = async (controller) => {
    setLoading(true);
    await apiClient
      .get(endpoint, {
        signal: controller.signal,
        ...requestConfig,
      })
      .then((res) => {
        if (res.data?.data) setData(res.data.data);
        else setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err instanceof CanceledError) return;
        setError(err.message);
        setLoading(false);
      });
  };

  return { data, error, loading, fetchData };
};

export { useData };
